{
  "home": {
    "tagline": "Mais de 1 milhão de donos de cães treinam com o Hundeo",
    "subline": "Recomendado por adestradores profissionais",
    "appStorePrefix": "Baixar na",
    "playStorePrefix": "Disponível no",
    "qrHint": "Abra o app no seu celular",
    "qrCaption": "Escaneie o código com a câmera",
    "socialProof": "5.000+ avaliações 5 estrelas",
    "imprint": "Imprint",
    "privacy": "Privacidade",
    "language": "Idioma",
    "openWebsite": "Ir para o site",
    "openInApp": "Abrir no app Hundeo",
    "openInAppHint": "Você será levado ao seu app",
    "openInAppButton": "Abrir",
    "promoRedirectTitle": "Abrindo sua oferta …",
    "promoRedirectButton": "Ir para sua oferta"
  }
}
